import { WithPermission } from 'src/providers/current-project.provider'
import AppointmentInfo from './appointment-info.component'
import { useTranslation } from 'react-i18next'
import { EPermissionGrantActions, EPermissionGrantSubjects } from 'src/pages/configuration/permissions/_components/permissions.type'
import { TPatientMedEvent } from 'src/types/med-event'
import { TFollowup } from 'src/types/followup'
import Card from 'src/components/card/card.component'
import { useCurrentPatientFile } from '../../../_components/patient-file.provider'
import { useModals } from 'src/providers/modals.provider'

export const getComingMedEvents = (medEvents: TPatientMedEvent[]) => {
  return medEvents
    ?.filter((medEvent) => new Date(medEvent.date) >= new Date())
    .filter((medEvent) => medEvent.date !== null)
    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
}

const ComingAppointment = ({
  patientMedEvents,
  currentFollowup,
}: {
  patientMedEvents: TPatientMedEvent[]
  currentFollowup: TFollowup
}) => {
  const { t } = useTranslation()
  const { patient, currentPatientFollowup } = useCurrentPatientFile()
  const { openFollowupModal } = useModals()
  const comingPatientMedEvents = getComingMedEvents(patientMedEvents) || []

  const hasComingMedEvent = comingPatientMedEvents.length > 0
  const canModifyPatientMedEvent =
    hasComingMedEvent && !currentPatientFollowup?.endReason && !currentFollowup.deletedAt

  return (
    <Card
      title={t('components.patient.patient-file.body.followup-details.next-appointments')}
      topRight={
        canModifyPatientMedEvent ? (
          <WithPermission
            requiredSubject={EPermissionGrantSubjects.PATIENT}
            requiredAction={EPermissionGrantActions.UPDATE}
          >
            <button
              className="c-text-primary-600 c-font-bold c-text-sm"
              onClick={() => {
                openFollowupModal({
                  patientId: patient.id,
                  patientFollowupIdToEdit: currentPatientFollowup?.id as number,
                })
              }}
            >
              {t('components.patient.patient-file.body.followup-details.edit')}
            </button>
          </WithPermission>
        ) : null
      }
    >
      {hasComingMedEvent ? (
        comingPatientMedEvents?.map((patientMedEvent) => (
          <AppointmentInfo
            patientMedEvent={patientMedEvent}
            currentFollowup={currentFollowup}
            key={patientMedEvent.id}
          />
        ))
      ) : (
        <p className="c-text-grey-600 c-mt-2">
          {t('components.patient.patient-file.body.followup-details.no-appointment')}
        </p>
      )}
    </Card>
  )
}

export default ComingAppointment
